import styled from 'styled-components'

export const FavoritesPlaceholderWrapper = styled.div`
  margin-right: 112px;
  display: flex;
  flex-direction: column;
`
export const ContentUnavailableWrapper = styled.div`
  height: 600px;
`
export const LoginButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 24px;
`
